import React from 'react';

type IconItemProps = {
  label: string;
  onClick?: () => void;
  isSelected: boolean;
};

const IconItem: React.FC<IconItemProps> = ({ label, onClick, isSelected }) => {
  return (
    <div
      style={{ textAlign: 'center', width: 150, cursor: 'pointer' }}
      onClick={onClick}
    >
      <div
        style={{
          width: 100,
          height: 100,
          backgroundColor: isSelected ? 'rgb(0, 244, 255)' : '#fff',
          borderRadius: '50%',
          border: '1px solid #eee',
          margin: '0 auto',
        }}
      />
      <div style={{ marginTop: 8, fontSize: 14 }}>{label}</div>
    </div>
  );
};

export default IconItem;
